import { CustomerAddress } from 'Types'

export const customerAddressTitle = (customerAddress: CustomerAddress): string =>
  `${customerAddress.address1}, ${customerAddress.city} ${customerAddress.zipCode}, ${customerAddress.country}`
